/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1r0i6kl{margin-inline:0;}
.f9b8bpc{padding-block:var(--spacingVerticalS);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fi15kbk{border-block-start-width:var(--strokeWidthThin);}
.f10zy6vx{border-block-end-width:var(--strokeWidthThin);}
.f32hy0g{border-inline-start-width:var(--strokeWidthThin);}
.fgmlvap{border-inline-end-width:var(--strokeWidthThin);}
.f1taw3pw{border-block-start-style:solid;}
.f1p2dij1{border-block-end-style:solid;}
.fwyddsq{border-inline-start-style:solid;}
.fwl1lcr{border-inline-end-style:solid;}
.foi3q75{border-block-start-color:var(--colorNeutralStroke2);}
.f1a566p{border-block-end-color:var(--colorNeutralStroke2);}
.f1ftuoky{border-inline-start-color:var(--colorNeutralStroke2);}
.f1crbv9w{border-inline-end-color:var(--colorNeutralStroke2);}
.fuzgk9b{min-inline-size:0;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1rktw8j{padding-inline:var(--spacingHorizontalXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f9c4gz4{justify-content:flex-end;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.fjg76ag{max-inline-size:320px;}
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1jat206{-webkit-padding-start:0;padding-inline-start:0;}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.f122n59{align-items:center;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f18qryls{padding-block:var(--spacingVerticalXXS);}
.f5j02bv{padding-inline:var(--spacingHorizontalS);}
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1dmdbja{background-color:var(--colorNeutralBackground2);}
.fqerorx{flex-grow:1;}
.fjksvth{overflow-wrap:anywhere;}
.f11d4kpn{color:var(--colorNeutralForeground3);}
.fmd5axg{min-inline-size:1.5em;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fkfq4zb{color:var(--colorNeutralForeground2);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.fni485r{flex-wrap:wrap;}
.fgs5rwf{align-items:flex-end;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.ffq3mkc{flex-basis:200px;}
.fjgzulp{align-self:flex-start;}
/** @griffel:css-end **/